import { motion } from "framer-motion";
import { AutoPlusLogo } from "@/components/brand/autoplus-logo";
import { homeHeroLayout } from "@/components/home/home-hero-layout";
import { cn } from "@/lib/utils";

/** Full-bleed hero plate · Porsche 911 Carrera GTS (village roadside). */
const HERO_BG_SRC = "/porsche-911-carrera-gts-village.webp";

export const HOME_HERO_IMAGE_SRC = HERO_BG_SRC;

type Props = {
  /** Reserved for future hero CTAs (auth-aware). */
  isAuthenticated?: boolean;
  showAddCar?: boolean;
};

export function HomeHeroSection(_props: Props = {}) {
  return (
    <section className={cn(homeHeroLayout.plate, "min-h-[70vh] sm:min-h-[78vh]")}>
      {/* Full-bleed visual plane */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG_SRC}
          alt=""
          width={1920}
          height={1080}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          className="size-full scale-105 object-cover object-[50%_58%]"
        />
        <div
          className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden"
          aria-hidden
        >
          <span className="select-none text-[22vw] font-extrabold leading-none tracking-tight text-white/[0.07] sm:text-[18vw]">
            PLUS
          </span>
        </div>
        <div
          className="absolute inset-0 bg-[linear-gradient(180deg,rgba(8,15,28,0.72)_0%,rgba(8,15,28,0.52)_42%,rgba(8,15,28,0.78)_78%,rgba(8,15,28,0.92)_100%)]"
          aria-hidden
        />
        <div
          className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,rgba(0,113,188,0.22),transparent_55%)]"
          aria-hidden
        />
      </div>

      <div className={cn(homeHeroLayout.stage, "min-h-[70vh] sm:min-h-[78vh]")}>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          className="flex max-w-3xl flex-col items-center"
          dir="rtl"
        >
          <h1>
            <AutoPlusLogo
              tone="onDark"
              className="h-16 w-auto max-w-[16rem] object-contain object-center sm:h-20 sm:max-w-[22rem] md:h-24 md:max-w-[28rem]"
            />
          </h1>

          <p className="mt-[0.42rem] max-w-lg text-balance text-lg font-medium leading-relaxed text-white/90 sm:text-xl md:text-2xl">
            اشترِ سيارة احلامك من  مزاد أو سعر ثابت
          </p>
        </motion.div>
      </div>
    </section>
  );
}
